import { render, staticRenderFns } from "./QuickSubmit.vue?vue&type=template&id=cb8729fa&scoped=true"
import script from "./QuickSubmit.vue?vue&type=script&lang=js"
export * from "./QuickSubmit.vue?vue&type=script&lang=js"
import style0 from "./QuickSubmit.vue?vue&type=style&index=0&id=cb8729fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8729fa",
  null
  
)

export default component.exports